import { Paper, Typography } from '@mui/material';
import React from 'react';

import { FontWeight } from '../../../../theme/typography';

interface RiskCardProps {
  color?: string;
  title: string;
}

/**
 * Card that displays the friendly name of the parameter risk level
 */
function RiskCard({ color = 'text.primary', title }: RiskCardProps) {
  return (
    <Paper
      sx={({ palette: { grey } }) => ({
        border: `1px solid ${grey[200]}`,

        backgroundColor: grey.A100,
        textAlign: 'center',
        alignContent: 'center',
        height: '100%',
        width: '100%',
        maxWidth: 230,
        maxHeight: 70,
        py: 4,
      })}
    >
      <Typography
        color={color}
        sx={{
          textTransform: 'uppercase',
          fontWeight: FontWeight.Bold,
          justifyContent: 'center',
        }}
        variant="h6"
      >
        {title}
      </Typography>
    </Paper>
  );
}

export default RiskCard;
